import { 
   SET_CURRENT_USER_DATA,
   SET_CURRENT_USER_LOGGED_IN_STATUS,
   SET_NAMES_FROM_HISTORY
 } from "../actionTypes";

 import { reactLocalStorage } from 'reactjs-localstorage';

const initialState = {
  isUserLoggedIn: reactLocalStorage.get('isUserLoggedIn', false),
  loggedInName: reactLocalStorage.get('isUserLoggedInFirstName', 'UserName'),
  canSignOut:false,
  fNameFromHistory:'',
  lNameFromHistory:''
};

const currentUser = (state = {...initialState}, action) => {
  switch (action.type) {
    case SET_CURRENT_USER_DATA: {
      
      const firstName = action.payload.profile?.given_name || 'UserName';
      return {...state, ...action.payload , loggedInName: firstName};
    }
    case SET_CURRENT_USER_LOGGED_IN_STATUS: {
      reactLocalStorage.set('isUserLoggedIn', action.payload.status);
      return {...state, isUserLoggedIn: action.payload.status,canSignOut:action.payload.status};
    }
    case SET_NAMES_FROM_HISTORY:{
      return {...state, fNameFromHistory:action.payload.fName, lNameFromHistory:action.payload.lName};
    }
    default: {
      return state;
    }
  }
};

export default currentUser;